import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import hostIntegration from "./integrations/host";
import "./i18n";
import "./css/tailwind.css";
import "./css/global.scss";

const rootElement = document.getElementById("root") as HTMLElement;
const tree = (
    <HelmetProvider>
        <App />
    </HelmetProvider>
);

const render = () => {
    if(rootElement.hasChildNodes()) {
        ReactDOM.hydrateRoot(rootElement, tree);
    } else {
        ReactDOM.createRoot(rootElement).render(tree);
    }
};

void hostIntegration.initialize();
render();
